<div class="somos-grid">
  <!-- Toolbar/Menu global del grid -->
  <div class="grid-toolbar" *ngIf="toolbarActions?.length">
    <button class="kebab-btn" type="button" (click)="toggleToolbar($event)" aria-haspopup="true"
            [attr.aria-expanded]="toolbarOpen">
      ⋮
    </button>

    <div class="toolbar-menu" *ngIf="toolbarOpen">
      <div class="toolbar-title">{{ toolbarTitle }}</div>
      <button
        class="toolbar-item"
        *ngFor="let a of toolbarActions"
        type="button"
        [disabled]="a.disabled"
        (click)="onToolbarActionClick(a, $event)">
        <span class="ti-icon" [innerHTML]="a.iconSvg || ''"></span>
        <span class="ti-label">{{ a.label }}</span>
      </button>
    </div>
  </div>

  <!-- Grid table -->
  <div class="table-wrapper">
    <table class="patients-table" [class.has-groups]="headerGroups?.length" [class.no-groups]="!headerGroups?.length">
      <colgroup *ngIf="colWidths?.length">
        <col *ngFor="let w of colWidths" [style.width]="w"/>
        <ng-container *ngIf="actions?.length">
          <col [style.width]="actionsColWidth || '72px'"/>
        </ng-container>
      </colgroup>
      <thead *ngIf="showHeader">
      <!-- Fila de GRUPOS (opcional) -->
      <tr class="group-row" *ngIf="headerGroups?.length">
        <th *ngFor="let g of headerGroups"
            [attr.colspan]="g.span"
            [class.group]="!!g.label"
            [class.blank]="!g.label"
            [class.closed]="g.class==='closed'"
            [class.bench]="g.class==='bench'"
            [ngClass]="[
          (g.align || 'center') === 'left'   ? 'align-left'   : '',
          (g.align || 'center') === 'center' ? 'align-center' : '',
          (g.align || 'center') === 'right'  ? 'align-right'  : ''
        ]">
          <span *ngIf="g.label">{{ g.label }}</span>
        </th>
        <!-- Si tienes columna de acciones, añade un th vacío al final -->
        <th *ngIf="actions?.length" [attr.colspan]="1" class="blank"></th>
      </tr>

      <!-- Fila de COLUMNAS (la que ya tenías) -->
      <tr class="cols-row">
        <th *ngFor="let col of columns"
            [style.width]="col.width"
            [class.sortable]="col.sortable"
            (click)="toggleSort(col)"
            [ngClass]="[
          (col.headerAlign || col.align || 'left') === 'left'   ? 'align-left'   : '',
          (col.headerAlign || col.align || 'left') === 'center' ? 'align-center' : '',
          (col.headerAlign || col.align || 'left') === 'right'  ? 'align-right'  : ''
        ]"
            [attr.aria-sort]="col.sortable && sortField===(col.sortFieldName || col.field)
                          ? (sortOrder===1 ? 'ascending' : sortOrder===-1 ? 'descending' : 'none')
                          : null">
          <ng-container *ngIf="!col.headerTemplate; else customHeader">
            {{ col.header }}
          </ng-container>
          <ng-template #customHeader>
            <ng-container [ngTemplateOutlet]="col.headerTemplate ?? null"></ng-container>
          </ng-template>

          <span class="sort-caret" *ngIf="col.sortable">
        <ng-container *ngIf="sortField===(col.sortFieldName || col.field); else inactiveSort">
          <i class="pi"
             [ngClass]="{
               'pi-sort-amount-up': sortOrder === 1,
               'pi-sort-amount-down': sortOrder === -1,
               'pi-sort-alt': sortOrder === 0
             }">
          </i>
        </ng-container>
        <ng-template #inactiveSort>
          <i class="pi pi-sort-alt"></i>
        </ng-template>
      </span>
        </th>

        <!-- header de acciones -->
        <th *ngIf="actions?.length" class="actions-header" [style.width]="actionsColWidth">
          {{ actionsHeader }}
        </th>
      </tr>
      </thead>


      <tbody>
      <!-- ✅ NUEVO: agrega let i = index -->
      <tr *ngFor="let row of pageSlice; let i = index"
          (click)="onRowClicked(row)"
          [attr.data-key]="dataKey ? row?.[dataKey] : null"
          [class.clickable]="rowClickable">
        <td *ngFor="let col of columns"
            [ngClass]="[
      (col.align || 'left') === 'left'   ? 'align-left'   : '',
      (col.align || 'left') === 'center' ? 'align-center' : '',
      (col.align || 'left') === 'right'  ? 'align-right'  : ''
    ]">
          <ng-container *ngIf="!col.template; else customCell">
            {{ getValue(row, col.field) }}
          </ng-container>
          <ng-template #customCell>
            <ng-container
              [ngTemplateOutlet]="col.template ?? null"
              [ngTemplateOutletContext]="{ $implicit: row, value: getValue(row, col.field) }">
            </ng-container>
          </ng-template>
        </td>


        <!-- ✅ NUEVO: celda de acciones por fila -->
        <td *ngIf="actions?.length" class="action-cell" (click)="$event.stopPropagation()">
          <button
            class="action-btn"
            type="button"
            aria-haspopup="true"
            [attr.aria-expanded]="openMenuRowKey === (dataKey ? row?.[dataKey] ?? i : i)"
            (click)="toggleRowMenu(row, i, $event)"
            title="Open actions">⋮
          </button>

          <!-- dentro de la celda de acciones, reemplaza SOLO el contenido del .action-menu -->
          <div class="action-menu"
               *ngIf="openMenuRowKey === (dataKey ? (row?.[dataKey] ?? i) : i)">
            <div class="am-title" *ngIf="actionsHeader">{{ actionsHeader || 'Options' }}</div>

            <ng-container *ngFor="let a of actions; let idx = index">
              <!-- separador antes de acciones “peligrosas” (id: 'delete' | 'cancel' | 'revoke') -->
              <div class="am-sep"
                   *ngIf="idx>0 && (a.id==='delete' || a.id==='cancel' || a.id==='revoke')"></div>

              <button
                class="am-item"
                [class.danger]="a.id==='delete' || a.id==='cancel' || a.id==='revoke'"
                [class.hidden]="!isVisible(a, row)"
                [disabled]="isDisabled(a, row)"
                (click)="onActionClick(a, row, $event)">
      <span class="am-icon" *ngIf="a.icon">
        <i *ngIf="a.icon.includes('pi ')" [class]="a.icon"></i>
        <ng-container *ngIf="!a.icon?.includes('pi ')">{{ a.icon }}</ng-container>
      </span>
                <span class="am-label">{{ a.label }}</span>
                <span class="am-kbd" *ngIf="a.id==='view'">↵</span>
              </button>
            </ng-container>
          </div>

        </td>
      </tr>

      <tr *ngIf="!loading && !pageSlice?.length">
        <!-- ✅ NUEVO: colspan incluye la columna de acciones si existe -->
        <td class="no-records" [attr.colspan]="columns.length + (actions?.length ? 1 : 0)">
          No records found.
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  <div class="pagination" *ngIf="paginator">
    <div class="pagination-left">
      <span class="rows-text">Rows per page:</span>
      <p-dropdown styleClass="page-size-select"
                  [options]="rowsPerPageOptions"
                  [autoDisplayFirst]="false"
                  appendTo="body"
                  [ngModel]="rows"
                  (ngModelChange)="changeRowsPerPage($event)">
      </p-dropdown>
    </div>
    <div class="pagination-right">
      <span class="page-info" *ngIf="showCurrentPageReport">{{ pageReport }}</span>
      <div class="pagination-buttons">
        <button class="page-btn" [disabled]="pageIndex===0" (click)="gotoFirst()">«</button>
        <button class="page-btn" [disabled]="pageIndex===0" (click)="gotoPrev()">‹</button>
        <button class="page-btn" [disabled]="pageIndex>=totalPages-1" (click)="gotoNext()">›</button>
        <button class="page-btn" [disabled]="pageIndex>=totalPages-1" (click)="gotoLast()">»</button>
      </div>
    </div>
  </div>
</div>
